import AnnualBalancesheet from "./AnnualBalancesheet";
import { Navigate, Route, useLocation, useParams } from "react-router-dom";

const ANNUAL_BALANCESHEET_PUBLIC_PATH =
  "davidson-evaluation/davidson/consultant/:slug/:token";

const AnnualBalancesheetLegacyRedirect = () => {
  const { slug, token } = useParams();
  const { search } = useLocation();

  return (
    <Navigate
      replace
      to={`/davidson-evaluation/davidson/consultant/${slug}/${token}${search}`}
    />
  );
};

const routes = {
  key: "ANNUAL_BALANCESHEET",
  routes: ({ userScope }) => [
    <Route
      key="annual-balancesheet-legacy"
      path={`balancesheet/annual/slug/:slug/:token`}
      element={<AnnualBalancesheetLegacyRedirect />}
    />,
    <Route
      key="annual-balancesheet-public"
      path={ANNUAL_BALANCESHEET_PUBLIC_PATH}
      element={<AnnualBalancesheet />}
    />,
    <Route
      key="annual-balancesheet-internal"
      path={`${userScope}/evaluation/professional-evaluation/show/consultant/:person_id/:slug/:year`}
      element={<AnnualBalancesheet />}
    />,
  ],
};
export default routes;
